import "whatwg-fetch";

import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import * as Redux from "redux";
import * as AppPath from "./model/AppPath";

import { Provider } from "react-redux";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { default as App } from "./App";
import createRootReducer from "./reducers";
import { Router, Route, matchPath } from "react-router-dom";
import { Utilities } from "shared/utilities";
import { renderNavBar } from "navigation";
import { State } from "./model/State";
import { LinkNames } from "navigation/App";
import StylesheetProvider from "shared/providers/StylesheetProvider";

const history = createBrowserHistory({
    basename: Utilities.getBaseUrlPath("")
});

export const processURLPatternBase = `/:base?/:processType(process|subprocess)/:action`;
export const processURLPattern = `${processURLPatternBase}/:id?`;

const processURL: AppPath.IProcessURL = matchPath(window.location.pathname, { path: processURLPattern })?.params as AppPath.IProcessURL || { processType: "process" };
const processType = processURL.processType.toLowerCase();

renderNavBar(history, LinkNames[processType as keyof typeof LinkNames], processURLPattern);

const composeEnhancer: typeof Redux.compose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || Redux.compose;

const store = Redux.createStore(
    createRootReducer(history),
    {},
    composeEnhancer(
        Redux.applyMiddleware(
            routerMiddleware(history),
            thunk as ThunkMiddleware<State, Redux.Action>
        ),
    )
);

const processEditorContainer = document.getElementById("processEditorContainer");
if (processEditorContainer) {
    const root = ReactDOM.createRoot(processEditorContainer);
    root.render(
        <StylesheetProvider>
            <Provider store={store}>
                <Router history={history}  >
                    <Route path={processURLPattern} component={App} />
                </Router>
            </Provider>
        </StylesheetProvider>
    );
}

export default store;
